module.exports = __webpack_public_path__ + "static/media/denied.18f7209c.gif";